var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "generate-trip-sheet"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [(_vm.showsidebar) ? _c('div', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "id": "sidebar-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-sidebar"
  }, [_c('button', {
    staticStyle: {
      "border": "0px",
      "font-size": "30px",
      "background": "white"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closesidebar
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(">>")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "1rem",
      "font-weight": "600"
    }
  }, [_c('div', {
    staticClass: "modal-sidebarfrm"
  }, [_c('p', [_vm._v("Trip Summary:\n                "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin": "0 54px"
    },
    on: {
      "click": _vm.getPendingScheduleMpsCountforTrip
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.CountForTrip), function(data, index) {
    return _c('tr', [_c('td'), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentAWB))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "red"
      },
      on: {
        "click": function($event) {
          return _vm.getPendingMpsCount(data.parentAWB, 'pending')
        }
      }
    }, [_vm._v(_vm._s(data.pendingcount))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "Green"
      },
      on: {
        "click": function($event) {
          return _vm.getPendingMpsCount(data.parentAWB, 'scheduled')
        }
      }
    }, [_vm._v(_vm._s(data.schedulecount))])])])
  })], 2)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: {
      'col-md-9': _vm.showsidebar, '': !_vm.showsidebar
    },
    style: ((_vm.showsidebar) ? 'max-width: 78%' : null)
  }, [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Bags Scan Out")]), (!_vm.showsidebar) ? _c('div', {
    staticClass: "col-md-12"
  }, [(false && _vm.showsidebutton) ? _c('button', {
    staticStyle: {
      "border": "0px",
      "font-size": "20px",
      "background": "white",
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showsidebarfn
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("<<")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('span', [_c('b', [_vm._v("Connection Vehicle Summary")])]), _vm._v(" "), (_vm.IsScheduleListData == true) ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue",
      "margin-left": "49%"
    },
    on: {
      "click": _vm.getVehicleCapacityDetails
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Vehicle Details")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backtoList
    }
  }, [_vm._v("Back To List")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "auto",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("THC No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CSMID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Capacity Kg.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Curr.Load Kg.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Avl.Capacity Kg.")]), _vm._v(" "), (_vm.triptype != 2) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Utilization")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Invoice No.")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.thcno))]) : _vm._e(), _vm._v(" "), (_vm.triptype == 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.lsptripmasterid))]) : _vm._e(), _vm._v(" "), (_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.tripid))]) : _vm._e(), _vm._v(" "), (_vm.triptype == 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.lsptripid))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.connectionschedulemasterid))]), _vm._v(" "), (_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.fullconnectionname))]) : _vm._e(), _vm._v(" "), (_vm.triptype == 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.connectionname))]) : _vm._e(), _vm._v(" "), (_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.vehicleno))]) : _vm._e(), _vm._v(" "), (_vm.triptype == 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.lspvehicleno))]) : _vm._e(), _vm._v(" "), (_vm.isBikerFlag) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v("Biker")]) : _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.vehiclename == "None" ? '' : _vm.schedulesList.vehiclename))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.Capacity)))]), _vm._v(" "), (_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.CurrLoad)))]) : _vm._e(), _vm._v(" "), (_vm.triptype == 2) ? _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.currentload)))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.AvailableCapacity)))]), _vm._v(" "), (_vm.triptype != 2) ? _c('td', {
    staticClass: "text-center"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('b', [_vm._v("B2B Loaded Kg.:")])]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.B2BLoad)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('b', [_vm._v("B2C Loaded Kg.:")])]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.B2CLoad)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('b', [_vm._v("B2B Utilization %:")])]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.B2BLoadPercentage)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "width": "62%"
    }
  }, [_c('b', [_vm._v("B2C Utilization %:")])]), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.B2CLoadPercentage)))])])])]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.vendorname == "null" ? '' : _vm.schedulesList.vendorname))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.schedulesList.invoiceno))])]), _vm._v(" "), (_vm.schedulesList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()])])])]), _vm._v(" "), _c('b-card', [(_vm.dockLoading) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": true,
      "is-full-screen": false
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isDockMandatory && !_vm.dockLoading) ? _c('fieldset', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-bottom": "25px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Dock ID:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.dockList,
      "selected-option": _vm.selectedDock,
      "name": "DockId",
      "placeholder": "Select Dock",
      "isDisabled": _vm.isDockDropdownDisabled
    },
    on: {
      "select": _vm.selectDock
    },
    model: {
      value: (_vm.dockId),
      callback: function($$v) {
        _vm.dockId = $$v
      },
      expression: "dockId"
    }
  })], 1), _vm._v(" "), (_vm.dockIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Dock ID is required.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Dock Barcode:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scannedDockBarcode),
      expression: "scannedDockBarcode"
    }],
    ref: "scanDockInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "scannedDockBarcode",
      "id": "scannedDockBarcode",
      "placeholder": "Scan / enter dock barcode",
      "autocomplete": "off",
      "disabled": _vm.isScanDockBarcodeDisabled
    },
    domProps: {
      "value": (_vm.scannedDockBarcode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onDockBarcodeScan.apply(null, arguments)
      },
      "change": _vm.onDockBarcodeScan,
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scannedDockBarcode = $event.target.value
      }
    }
  })])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.dockbarcode || _vm.isDockIn
    },
    on: {
      "click": function($event) {
        return _vm.dockIn()
      }
    }
  }, [_vm._v("Dock In")]), _vm._v("  \n\n                    "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.isDockIn
    },
    on: {
      "click": function($event) {
        return _vm.openChangeDockModal()
      }
    }
  }, [_vm._v("Change Dock")])])], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScanOut),
      expression: "showScanOut"
    }],
    staticClass: "col-xs-12"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabledPrv
    },
    on: {
      "click": _vm.prvTouchPoint,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Prev.")]), _vm._v("  \n                      "), _c('span', {
    staticClass: "btn",
    staticStyle: {
      "color": "white",
      "background-color": "#1B5E20!important"
    },
    model: {
      value: (_vm.tchPointHubId),
      callback: function($$v) {
        _vm.tchPointHubId = $$v
      },
      expression: "tchPointHubId"
    }
  }, [_vm._v(_vm._s(_vm.tchPointHubName))]), _vm._v("  \n                      "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisabledNxt
    },
    on: {
      "click": _vm.nxtTouchPoint,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "fa fa-angle-double-right"
  })]), _vm._v(" \n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-shopping-bag'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BagNo),
      expression: "BagNo"
    }],
    ref: "BagNo",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "BagNo",
      "id": "BagNo",
      "autocomplete": "off",
      "disabled": _vm.isDockMandatory && !_vm.isDockIn
    },
    domProps: {
      "value": (_vm.BagNo)
    },
    on: {
      "keydown": function($event) {
        (_vm.restrictionConfig && _vm.restrictionConfig.outscanmanualrestrict) ? _vm.restrictManualTyping($event): null
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "paste": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "copy": [function($event) {
        $event.preventDefault();
      }, function($event) {
        $event.preventDefault();
      }],
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.scanOutBag.apply(null, arguments)
      }, _vm.CheckBagNoError],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.BagNo = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.BagNoError))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "margin-top": "27px"
    }
  }, [(this.schedulesList.triptype != 'External Partner') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isDockMandatory && !_vm.isDockIn
    },
    on: {
      "click": _vm.scanOutBag
    }
  }, [_vm._v("Scan Out")]) : _vm._e(), _vm._v("  \n                    "), (this.schedulesList.triptype == 'External Partner') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isDockMandatory && !_vm.isDockIn
    },
    on: {
      "click": _vm.scanOutLspBag
    }
  }, [_vm._v("Scan Out")]) : _vm._e(), _vm._v("  \n                    \n                    "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openPaperWorkCard
    }
  }, [_vm._v("Paper Work")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getPendingWorkBagList
    }
  }, [_vm._v("Pending List")]), _vm._v(" "), (_vm.restrictionConfig.isIRTUserExceptionLoc) ? _c('button', {
    staticClass: "common-warning",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.exceptionModal = true, _vm.Trackingno = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v("  Capture Exception")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReasonList),
      expression: "showReasonList"
    }],
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Surface Mode Reasons")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sSurfaceModeReasons),
      expression: "sSurfaceModeReasons"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "sSurfaceModeReasons",
      "id": "sSurfaceModeReasons"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sSurfaceModeReasons = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.clearsSurfaceModeReasonsError]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Reason")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Air connection not available"
    }
  }, [_vm._v("Air connection not available")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Dangerous Goods Screening"
    }
  }, [_vm._v("Dangerous Goods Screening")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Embargo Declared"
    }
  }, [_vm._v("Embargo Declared")])])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.sSurfaceModeReasonsError))])], 1)], 1)])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "sm",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.showB2BConfirmModal),
      callback: function($$v) {
        _vm.showB2BConfirmModal = $$v
      },
      expression: "showB2BConfirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelB2BLoadPlan
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("You are opening B2B Load Plan for Cargo. Do you want to continue?")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.confirmB2BLoadPlan
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.cancelB2BLoadPlan
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "sm",
      "hide-footer": "",
      "centered": ""
    },
    model: {
      value: (_vm.showB2BPendencyConfirmModal),
      callback: function($$v) {
        _vm.showB2BPendencyConfirmModal = $$v
      },
      expression: "showB2BPendencyConfirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelB2BLoadPendency
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("You are opening B2B Load Pendency for Cargo. Do you want to continue?")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": _vm.confirmB2BLoadPendency
    }
  }, [_vm._v("OK")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.cancelB2BLoadPendency
    }
  }, [_vm._v("Cancel")])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.IsPaperWorkBag = false
      }
    },
    model: {
      value: (_vm.IsPaperWorkBag),
      callback: function($$v) {
        _vm.IsPaperWorkBag = $$v
      },
      expression: "IsPaperWorkBag"
    }
  }, [(_vm.isRemoveEvent == false && _vm.isAWBRemoveEvent == false) ? _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Scan In: Paper Bag & AWB details")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePaperWorkCard
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isInscanSuccess
    },
    on: {
      "update:active": function($event) {
        _vm.isInscanSuccess = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Connection Name: ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', [_vm._v(_vm._s(_vm.schedulesList.fullconnectionname))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Touch Point Hub Name:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('span', [_vm._v(_vm._s(_vm.tchPointHubName))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Bag No:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paperbagno),
      expression: "paperbagno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "paperbagno",
      "id": "paperbagno",
      "autocomplete": "off",
      "disabled": _vm.isExistBag
    },
    domProps: {
      "value": (_vm.paperbagno)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcodeForPaperBagOrParentAWB($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paperbagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.PaperBagNoError))])], 1)]), _vm._v(" "), (_vm.paperbagno && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.openPaperWorkCard
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Bag Details")])]) : _vm._e(), _vm._v(" "), (_vm.isBagData && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle Capacity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle Current Load")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle Expected Load")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Vehicle Available Capacity")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.paperstatus))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.vehiclecapacity))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.vehiclecurrentload))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.ExpectedB2BWeight))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.vehicleavailablecapacity))])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isReloadTable && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.getGeneratedPaperBagNoDetails
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Paper Bag AWB details")])]) : _vm._e(), _vm._v(" "), (_vm.isReloadTable && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('span', [(_vm.IsPaperNo == true) ? _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "50%",
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "button",
      "active": _vm.isRemoveRowLoader
    },
    on: {
      "click": _vm.openParentAWBCard,
      "update:active": function($event) {
        _vm.isRemoveRowLoader = $event
      }
    }
  }, [_vm._v("Remove Parent AWB")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isReloadTable && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Weight (Avl./Total)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("MPS Count (Avl./Total)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Position")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.generatedPaperBagNoDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawbweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.position))])])
  }), _vm._v(" "), (_vm.generatedPaperBagNoDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])])]) : _vm._e(), _vm._v(" "), (_vm.cargolimitexceedmodal) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IsAllow),
      expression: "IsAllow"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsAllow",
      "value": "IsAllow"
    },
    domProps: {
      "checked": Array.isArray(_vm.IsAllow) ? _vm._i(_vm.IsAllow, "IsAllow") > -1 : (_vm.IsAllow)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.IsAllow,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IsAllow",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.IsAllow = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.IsAllow = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.IsAllow = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "IsAllow"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b', {
    staticStyle: {
      "color": "red",
      "margin-left": "-10%"
    }
  }, [_vm._v(_vm._s(_vm.cargolimitexceedmsg))])])]) : _vm._e(), _vm._v(" "), (_vm.IsPaperNo == true && _vm.paperstatus == 'BagOpen' || _vm.paperstatus == 'Schedule') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Parent AWB:")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paperno),
      expression: "paperno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Parent AWB",
      "name": "paperno",
      "id": "paperno",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.paperno)
    },
    on: {
      "keypress": function($event) {
        return _vm.checkBarcodeForPaperBagOrParentAWB($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.paperno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.PaperNoError))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(_vm.IsPaperNo == false) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generatePaperBagNo
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.IsPaperNo == true) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.inscanPaperNo
    }
  }, [_vm._v("Inscan")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPaperBagNo
    }
  }, [_vm._v("Reset")])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isRemoveEvent == true) ? _c('div', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Scan: Parent AWB")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRemoveParentAWBCard
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isRemoveRowLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isRemoveRowLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentAWB),
      expression: "parentAWB"
    }],
    ref: "perentAWB",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Parent AWB",
      "name": "parentAWB",
      "id": "parentAWB",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.parentAWB)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.RemoveRow(_vm.paperbagno)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.parentAWBError))])], 1)])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isAWBRemoveEvent == true) ? _c('div', [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Scan: Bag/ Shipment (MPS)")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.IsPaperWorkBag = false, _vm.closeRemoveParentAWBCard()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isRemoveRowLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isRemoveRowLoader = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childAWB),
      expression: "childAWB"
    }],
    ref: "childAWB",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag/MPS",
      "name": "childAWB",
      "id": "childAWB",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.childAWB)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.removeBagScheduledBag()
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.childAWB = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.childAWBError))])], 1)])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-backdrop": _vm.isSysExcp,
      "no-close-on-esc": _vm.isSysExcp,
      "hide-footer": "",
      "centered": "",
      "modal-class": "exception-modal",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', {
          staticClass: "ex-header ex-divider"
        }, [_c('div', {
          staticClass: "ex-title"
        }, [_c('span', {
          staticClass: "warn"
        }, [_c('i', {
          staticClass: "fa fa-warning"
        })]), _c('span', [_vm._v("Capture Exception")]), _vm._v(" "), (_vm.isSysExcp) ? _c('span', {
          staticClass: "ex-badge"
        }, [_vm._v("Exception ID #" + _vm._s(_vm.Trackingno))]) : _vm._e()]), _vm._v(" "), (!_vm.isSysExcp) ? _c('button', {
          staticClass: "close exheader-close",
          attrs: {
            "type": "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            "click": function($event) {
              return _vm.resetIRTParams()
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])]) : _vm._e()])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.exceptionModal),
      callback: function($$v) {
        _vm.exceptionModal = $$v
      },
      expression: "exceptionModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.exLoading
    },
    on: {
      "update:active": function($event) {
        _vm.exLoading = $event
      }
    }
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "ex-info"
  }, [_c('span', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _c('span', [_vm._v("Provide details regarding the shipment exception for records and follow-up.")])]), _vm._v(" "), _c('div', {
    staticClass: "ex-body"
  }, [_c('label', [_vm._v("AWB Number / Flyer ID / Bag Seal ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionAWB),
      expression: "exceptionAWB"
    }],
    staticClass: "ex-input",
    attrs: {
      "placeholder": "Enter or Scan AWB / Flyer / Bag ID",
      "disabled": _vm.isSysExcp
    },
    domProps: {
      "value": (_vm.exceptionAWB)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionAWB = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Error / Exception Message "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionError),
      expression: "exceptionError"
    }],
    staticClass: "ex-input",
    attrs: {
      "placeholder": "Enter Error / Exception Message",
      "disabled": _vm.isSysExcp
    },
    domProps: {
      "value": (_vm.exceptionError)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionError = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excErr),
      expression: "excErr"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.excErr))]), _vm._v(" "), _c('label', [_vm._v("Exception Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionType),
      expression: "exceptionType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "ex-input",
    attrs: {
      "disabled": _vm.isSysExcp,
      "name": "Select Exception Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.exceptionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Exception Type")]), _vm._v(" "), _vm._l((_vm.exceptionTypeList), function(exceptionT) {
    return _c('option', {
      domProps: {
        "value": exceptionT.value
      }
    }, [_vm._v(_vm._s(exceptionT.text))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excTypErr),
      expression: "excTypErr"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.excTypErr))]), _vm._v(" "), _c('label', [_vm._v("Comments / Additional Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionComment),
      expression: "exceptionComment"
    }],
    staticClass: "ex-input",
    attrs: {
      "rows": "4",
      "max-rows": "10",
      "cols": "50",
      "placeholder": "Describe the exception in detail..."
    },
    domProps: {
      "value": (_vm.exceptionComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionComment = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isSysExcp) ? _c('div', {
    staticClass: "ex-footer ex-divider-top"
  }, [_c('button', {
    staticClass: "ex-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.raiseException()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("Update Exception")])]) : _c('div', {
    staticClass: "ex-footer ex-divider-top"
  }, [_c('button', {
    staticClass: "ex-btn-trans",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetIRTParams()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ex-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.raiseException()
      }
    }
  }, [_vm._v("Submit Exception")])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "centered": "",
      "modal-class": "success-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', {
          staticClass: "success-header"
        }, [_c('div', {
          staticClass: "header-left"
        }, [_c('i', {
          staticClass: "fa fa-check-circle"
        }), _c('span', [_vm._v("SUCCESS CONFIRMATION")])]), _vm._v(" "), _c('button', {
          staticClass: "close header-close",
          attrs: {
            "type": "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            "click": function($event) {
              return _vm.resetIRTParams()
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.exSuccModal),
      callback: function($$v) {
        _vm.exSuccModal = $$v
      },
      expression: "exSuccModal"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "success-body"
  }, [_c('div', {
    staticClass: "check-circle"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.logMessage))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Generated Exception ID")]), _vm._v(" "), _c('div', {
    staticClass: "id-box"
  }, [_vm._v("# " + _vm._s(_vm.Trackingno))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-handle"
  })])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.scanPaperWorkBagParentAWB = false
      }
    },
    model: {
      value: (_vm.scanPaperWorkBagParentAWB),
      callback: function($$v) {
        _vm.scanPaperWorkBagParentAWB = $$v
      },
      expression: "scanPaperWorkBagParentAWB"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  })]), _vm._v(" "), (_vm.showList) ? _c('div', [_c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Pending List Of Parent MPS")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("Total Records: " + _vm._s(_vm.PendingParentMPSDetailsList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn-default navbar-btn pull-right",
    attrs: {
      "title": "Close List",
      "type": "button"
    },
    on: {
      "click": _vm.closePendingWorkBagList
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingParentMPS
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingParentMPS = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', {
    staticStyle: {
      "margin": "14px",
      "width": "1032px"
    }
  }, [_c('div', {
    staticClass: "scrollit"
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Parent MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Hub")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.PendingParentMPSDetailsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ParentMPS))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v("Cargo")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.VolumetricWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ChargeableWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PhysicalWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.OriginHubID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))])])
  }), 0), _vm._v(" "), (_vm.PendingParentMPSDetailsList.length == 0) ? _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])])]) : _vm._e()])])])], 1)])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Partial Connection Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('b-card', [_c('p', [_vm._v("Please select reason")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.reasonlist,
      "selected-option": _vm.selectedReason,
      "placeholder": "Select Reason",
      "name": "reason"
    },
    on: {
      "select": _vm.selectedReasonType
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1), _vm._v(" "), (_vm.reasonErrorFlg) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.reasonErrorMsg))]) : _vm._e()], 1)], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectReasonCheck
    }
  }, [_vm._v("Save changes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.IsScheduleListData == true) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.getPendingScheduledBagCount
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload Pending/ScheduleBag Count")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Pending Bags Count: " + _vm._s(_vm.PendingBagsCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Scheduled Bags Count: " + _vm._s(_vm.ScheduledBagsCount))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('button', {
    staticClass: "tablinks tabbutton",
    attrs: {
      "id": "tabPendingBagsOrShipment"
    },
    on: {
      "click": [function($event) {
        return _vm.openTab($event, 'PendingBagsOrShipment')
      }, _vm.checkpending]
    }
  }, [_vm._v("Pending Bags/Shipment")]), _vm._v(" "), _c('button', {
    staticClass: "tablinks tabbutton",
    attrs: {
      "id": "tabScheduleBagsORShipment"
    },
    on: {
      "click": [function($event) {
        return _vm.openTab($event, 'ScheduleBagsORShipment')
      }, _vm.checkschedule]
    }
  }, [_vm._v("Schedule Bags/Shipment")]), _vm._v(" "), (_vm.showB2BLoadPlanTab) ? _c('button', {
    staticClass: "tablinks tabbutton",
    attrs: {
      "id": "tabB2BLoadPlan"
    },
    on: {
      "click": _vm.openB2BLoadPlan
    }
  }, [_vm._v("B2B Load Plan")]) : _vm._e(), _vm._v(" "), (_vm.showB2BLoadPlanTab) ? _c('button', {
    staticClass: "tablinks tabbutton",
    attrs: {
      "id": "tabB2BLoadPendency"
    },
    on: {
      "click": _vm.openB2BLoadPendency
    }
  }, [_vm._v("B2B Load Pendency")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    attrs: {
      "id": "PendingBagsOrShipment"
    }
  }, [_c('div', {
    staticClass: "form group row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "tabCargo"
    },
    on: {
      "change": function($event) {
        return _vm.checkcargo()
      }
    }
  }), _vm._v(" Cargo"), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "id": "tabECOM"
    },
    on: {
      "click": function($event) {
        return _vm.checkeco()
      }
    }
  }), _vm._v(" ECOM"), _c('br')]), _vm._v(" "), (_vm.checkECOM == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.ecomhubitem,
      "placeholder": "Select Destination Hub"
    },
    on: {
      "select": _vm.SelectECOMHub
    },
    model: {
      value: (_vm.ecomhubname),
      callback: function($$v) {
        _vm.ecomhubname = $$v
      },
      expression: "ecomhubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.ecomhubnameError))])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkECOM == 1) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%"
    },
    on: {
      "click": _vm.getPendingShipments
    }
  }, [_vm._v("Show List")]), _vm._v(" "), (_vm.pendingBagsPriorityCount) ? _c('div', {
    staticClass: "new-par"
  }, [_c('b', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_vm._v("All (" + _vm._s(_vm.PendingScheduleShipmentsList.length) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%",
      "background-color": "white",
      "color": "#20a8d8"
    }
  }, [_vm._v("P0 (" + _vm._s(_vm.pendingBagsPriorityCount.P0_totalbags) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%",
      "background-color": "white",
      "color": "#20a8d8"
    }
  }, [_vm._v("P1 (" + _vm._s(_vm.pendingBagsPriorityCount.P1_totalbags) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%",
      "background-color": "white",
      "color": "#20a8d8"
    }
  }, [_vm._v("P2 (" + _vm._s(_vm.pendingBagsPriorityCount.P2_totalbags) + ")")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "2%",
      "background-color": "white",
      "color": "#20a8d8"
    }
  }, [_vm._v("P3 (" + _vm._s(_vm.pendingBagsPriorityCount.P3_totalbags) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "priority-timestamp"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Date & Time: " + _vm._s(_vm._f("moment")(_vm.pendingBagsPriorityCount.createdDate)))])], 1)])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.checkCargo == 1) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-bank'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.cargohubitem,
      "placeholder": "Select Destination Hub"
    },
    on: {
      "select": _vm.SelectCargoHub
    },
    model: {
      value: (_vm.cargohubname),
      callback: function($$v) {
        _vm.cargohubname = $$v
      },
      expression: "cargohubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.cargohubnameError))])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.checkCargo == 1) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('b-form-fieldset', [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "1%"
    },
    on: {
      "click": _vm.getPendingBags
    }
  }, [_vm._v("Show List")])])], 1) : _vm._e()])]), _vm._v(" "), (_vm.checkCargo == 1) ? _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingBags
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingBags = $event
      }
    }
  }), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pending Schedule Bags List")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "550px",
      "margin-top": "2px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No/MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PendingScheduleBagsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentmps || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), (_vm.PendingScheduleBagsList.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1) : _vm._e(), _vm._v(" "), (_vm.checkECOM == 1) ? _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingShipments
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingShipments = $event
      }
    }
  }), _c('br'), _vm._v(" "), _c('span', [_c('b', [_vm._v("Pending Schedule Shipments List")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "550px",
      "margin-top": "20px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Connection Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("CB Bag")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current HubId")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Priority")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Ageing Info")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.PendingScheduleShipmentsList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.connectionid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.cbbag))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubid))]), _vm._v(" "), _c('td', _vm._b({
      staticClass: "text-center"
    }, 'td', data.lossCategorization && data.lossCategorization.icon ? _vm.getCenteredIconStyle(data.lossCategorization.colorCode, data.lossCategorization.icon) : null, false), [_vm._v(" ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((data.ageinginfo.days) ? data.ageinginfo.days + 'd' : '0d') + _vm._s((data.ageinginfo.hours) ? data.ageinginfo.hours + 'h' : '0h') + _vm._s((data.ageinginfo.minutes) ? data.ageinginfo.minutes + 'm' : '0m'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), (_vm.PendingScheduleShipmentsList.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "15"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tabcontent",
    attrs: {
      "id": "ScheduleBagsORShipment"
    }
  }, [_c('div', {}, [_c('legend', [_vm._v("Schedule Bags/Shipment")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.reloadingScannedOutBagsList
    },
    on: {
      "update:active": function($event) {
        _vm.reloadingScannedOutBagsList = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.showConfirmAllocation
    }
  }, [_c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reload ScanOut Bags")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "70%"
    }
  }, [(((_vm.ScheduledBagsCount > 0) || (_vm.scheduledBagCount && _vm.scheduledBagCount.count > 0))) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openRemoveMPSCard()
      }
    }
  }, [_vm._v("Remove Bag/Shipment")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "250px",
      "margin-top": "5px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Priority")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.scheduledBagCount.Data), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.volumetricweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.chargeableweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.physicalweight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', _vm._b({
      staticClass: "text-center"
    }, 'td', data.lossCategorization && data.lossCategorization.icon ? _vm.getCenteredIconStyleSchdule(data.lossCategorization.colorCode, data.lossCategorization.icon) : null, false), [_vm._v(" ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.createddate)))])])
  }), _vm._v(" "), ((_vm.scheduledBagCount && _vm.scheduledBagCount.length == 0) || _vm.scheduledBagCount.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB2BLoadPlanActive),
      expression: "isB2BLoadPlanActive"
    }],
    staticStyle: {
      "padding": "6px 12px",
      "border": "1px solid #ccc",
      "border-top": "none"
    },
    attrs: {
      "id": "B2BLoadPlan"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingB2BLoadPlan
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingB2BLoadPlan = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "margin": "0"
    }
  }, [_vm._v("B2B Load Plan")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        return _vm.getB2BLoadPlanData(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.exportB2BLoadPlanExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Excel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.printB2BLoadPlan
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print PDF")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.closeB2BLoadPlan
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px",
      "padding": "10px",
      "background": "#f5f5f5",
      "border": "1px solid #ddd",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Connection:")]), _vm._v(" " + _vm._s(_vm.schedulesList.fullconnectionname))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Trip ID:")]), _vm._v(" " + _vm._s(_vm.schedulesList.tripid))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Vehicle:")]), _vm._v(" " + _vm._s(_vm.schedulesList.vehicleno))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.b2bLoadPlanResponse.createddate)))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total AWBs")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.b2bLoadPlanData.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total MPS count")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#28a745"
    }
  }, [_vm._v(_vm._s(_vm.b2bLoadPlanData.reduce(function (sum, item) { return sum + (item.mpscount || 0); }, 0)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total weight (Kg)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.b2bLoadPlanData.reduce(function (sum, item) { return sum + (item.weight || 0); }, 0))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Avl. vehicle capacity (Kg)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#28a745"
    }
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.AvailableCapacity)))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "max-height": "550px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "1"
    }
  }, [_c('tr', {
    staticClass: "text-dark"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pallet Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Weight (Kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Touchpoint Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Inscan time (1st MPS)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Days to PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Priority rank")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.b2bLoadPlanData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.parentmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.clientAccountName || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatBinPallet(item.bin)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatBinPallet(item.pallet)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.weight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.touchpointhubname || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.inscantime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: ({
        'color': item.breachdays != null && item.breachdays <= 0 ? '#dc3545' : item.breachdays != null && item.breachdays > 0 ? '#007bff' : '#6c757d'
      })
    }, [_vm._v("\n                      " + _vm._s(item.breachdays != null ? item.breachdays : '--') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      style: ({
        'display': 'inline-block',
        'width': '30px',
        'height': '30px',
        'line-height': '30px',
        'border-radius': '50%',
        'text-align': 'center',
        'font-weight': 'bold',
        'border': '2px solid ' + (item.priorityrank == 1 ? '#ff8c00' : item.priorityrank == 2 ? '#007bff' : item.priorityrank == 3 ? '#28a745' : '#6c757d'),
        'color': item.priorityrank == 1 ? '#ff8c00' : item.priorityrank == 2 ? '#007bff' : item.priorityrank == 3 ? '#28a745' : '#6c757d'
      })
    }, [_vm._v("\n                        " + _vm._s(item.priorityrank) + "\n                      ")])])])
  }), _vm._v(" "), (_vm.b2bLoadPlanData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isB2BLoadPendencyActive),
      expression: "isB2BLoadPendencyActive"
    }],
    staticStyle: {
      "padding": "6px 12px",
      "border": "1px solid #ccc",
      "border-top": "none"
    },
    attrs: {
      "id": "B2BLoadPendency"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingB2BLoadPendency
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingB2BLoadPendency = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold",
      "margin": "0"
    }
  }, [_vm._v("B2B Load Pendency")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-default btn-sm",
    on: {
      "click": function($event) {
        return _vm.getB2BLoadPendencyData(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.exportB2BLoadPendencyExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export Excel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.printB2BLoadPendency
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print PDF")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    staticStyle: {
      "margin-left": "5px"
    },
    on: {
      "click": _vm.closeB2BLoadPendency
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Cancel")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px",
      "padding": "10px",
      "background": "#f5f5f5",
      "border": "1px solid #ddd",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Connection:")]), _vm._v(" " + _vm._s(_vm.schedulesList.fullconnectionname))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Trip ID:")]), _vm._v(" " + _vm._s(_vm.schedulesList.tripid))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Vehicle:")]), _vm._v(" " + _vm._s(_vm.schedulesList.vehicleno))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(_vm.b2bLoadPendencyResponse.createddate)))])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total AWBs")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.b2bLoadPendencyData.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total MPS count")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#28a745"
    }
  }, [_vm._v(_vm._s(_vm.b2bLoadPendencyData.reduce(function (sum, item) { return sum + (item.mpscount || 0); }, 0)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Total weight (Kg)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.b2bLoadPendencyData.reduce(function (sum, item) { return sum + (item.weight || 0); }, 0))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ddd",
      "padding": "10px",
      "text-align": "center",
      "border-radius": "4px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#000",
      "font-weight": "bold"
    }
  }, [_vm._v("Avl. vehicle capacity (Kg)")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold",
      "color": "#28a745"
    }
  }, [_vm._v(_vm._s(_vm._f("toFixedNum")(_vm.VehicleCapacityDataList.AvailableCapacity)))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "max-height": "550px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "position": "sticky",
      "top": "0",
      "z-index": "1"
    }
  }, [_c('tr', {
    staticClass: "text-dark"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pallet Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Weight (Kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Touchpoint Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Inscan time (1st MPS)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Days to PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Priority rank")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.b2bLoadPendencyData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.parentmps))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.clientAccountName || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatBinPallet(item.bin)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatBinPallet(item.pallet)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(item.weight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(item.touchpointhubname || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.inscantime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: ({
        'color': item.breachdays != null && item.breachdays <= 0 ? '#dc3545' : item.breachdays != null && item.breachdays > 0 ? '#007bff' : '#6c757d'
      })
    }, [_vm._v("\n                      " + _vm._s(item.breachdays != null ? item.breachdays : '--') + "\n                    ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      style: ({
        'display': 'inline-block',
        'width': '30px',
        'height': '30px',
        'line-height': '30px',
        'border-radius': '50%',
        'text-align': 'center',
        'font-weight': 'bold',
        'border': '2px solid ' + (item.priorityrank == 1 ? '#ff8c00' : item.priorityrank == 2 ? '#007bff' : item.priorityrank == 3 ? '#28a745' : '#6c757d'),
        'color': item.priorityrank == 1 ? '#ff8c00' : item.priorityrank == 2 ? '#007bff' : item.priorityrank == 3 ? '#28a745' : '#6c757d'
      })
    }, [_vm._v("\n                        " + _vm._s(item.priorityrank) + "\n                      ")])])])
  }), _vm._v(" "), (_vm.b2bLoadPendencyData.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showcnfrmAllocation),
      expression: "showcnfrmAllocation"
    }],
    staticClass: "col-xs-12"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearchForCargoPending
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearchForCargoPending = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    attrs: {
      "name": "PaperBagTab"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitPaperBag('PaperBagTab')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Paper Bag No [ Pending: "), _c('span', {
    staticStyle: {
      "color": "red",
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.getPendingPaperBagDetails
    }
  }, [_vm._v(_vm._s(_vm.PendingCount))]), _vm._v(" | OutScanned: "), _c('span', {
    staticStyle: {
      "color": "#008000",
      "cursor": "pointer",
      "font-weight": "bold"
    },
    on: {
      "click": _vm.getOutscanPaperBagDetails
    }
  }, [_vm._v(_vm._s(_vm.OutScanCount))]), _vm._v(" ]")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-bag'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.finalpaperbagno),
      expression: "finalpaperbagno"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Paper Bag No",
      "name": "finalpaperbagno",
      "id": "finalpaperbagno",
      "data-vv-scope": "PaperBagTab",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.finalpaperbagno)
    },
    on: {
      "keyup": [_vm.clearFinalPaperBagNoError, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.scanOutPaperBag.apply(null, arguments)
      }],
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.finalpaperbagno = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FinalPaperBagNoError))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.scanOutPaperBag
    }
  }, [_vm._v("Scan Out Paper Bag")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetPaperBag
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "name": "Tab"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitSealNo('Tab')
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('span', [_c('b', [_vm._v("Total Scan Out Bags : " + _vm._s(_vm.scheduledBagCount.count || 0))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('span', [_c('b', [_vm._v(" Cumulative Weight(kgs) : " + _vm._s(_vm._f("toFixedNum")(_vm.scheduledBagCount.weight || 0)) + " ")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Vehicle Seal No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-bookmark'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.VehicleSealNo),
      expression: "VehicleSealNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "VehicleSealNo",
    class: {
      'form-control': true, 'error': _vm.errors.has('Tab.VehicleSealNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Vehicle Seal No",
      "data-vv-scope": "Tab",
      "name": "VehicleSealNo",
      "id": "VehicleSealNo",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.VehicleSealNo)
    },
    on: {
      "keydown": function($event) {
        (_vm.restrictionConfig && _vm.restrictionConfig.isrestrictvehiclesealmanualoutscan) ? _vm.restrictManualTyping($event): null
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.VehicleSealNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tab.VehicleSealNo')),
      expression: "errors.has('Tab.VehicleSealNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tab.VehicleSealNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Current KM.")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-road'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CurrentKM),
      expression: "CurrentKM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('Tab.CurrentKM')
    },
    attrs: {
      "type": "number",
      "placeholder": "Enter Current KM",
      "data-vv-scope": "Tab",
      "name": "CurrentKM",
      "id": "CurrentKM",
      "min": "0"
    },
    domProps: {
      "value": (_vm.CurrentKM)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CurrentKM = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tab.CurrentKM')),
      expression: "errors.has('Tab.CurrentKM')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Tab.CurrentKM')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [(this.schedulesList.triptype != 'External Partner') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.confirmAllocation
    }
  }, [_vm._v("Confirm Allocation")]) : _vm._e(), _vm._v(" \n                    "), (this.schedulesList.triptype == 'External Partner') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.confirmLspAllocation
    }
  }, [_vm._v("Confirm Allocation")]) : _vm._e(), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.cancelAllocation
    }
  }, [_vm._v("Cancel")]), _vm._v(" \n                    "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.getCargoPendingList
    }
  }, [_vm._v("Pending List")]), _vm._v(" \n                  ")])])], 1)])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.PaperBagPendingOutscanListModel),
      callback: function($$v) {
        _vm.PaperBagPendingOutscanListModel = $$v
      },
      expression: "PaperBagPendingOutscanListModel"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Paper Bag Pending/Scheduled List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePaperBagPendingOutscanListModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    attrs: {
      "id": "printData"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable3",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("TP")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")])]), _vm._v(" "), _vm._l((_vm.CountDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.stoppointhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))])])
  }), _vm._v(" "), (_vm.CountDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "id": "#confirmationmodal",
      "title": "MPSList"
    },
    model: {
      value: (_vm.AWBPendingOutscanListModel),
      callback: function($$v) {
        _vm.AWBPendingOutscanListModel = $$v
      },
      expression: "AWBPendingOutscanListModel"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_vm._v(_vm._s(_vm.Title))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAWBPendingOutscanListModel
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    class: {
      'scrollitclspending': (_vm.PendingMpsListArr.length > 10), '': (_vm.PendingMpsListArr.length <= 10)
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover datatables tbl",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_vm._l((_vm.PendingMpsListArr), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data))])])
  }), _vm._v(" "), (_vm.PendingMpsListArr.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModalForCargoPendingList),
      expression: "showModalForCargoPendingList"
    }],
    attrs: {
      "size": "lg",
      "title": "Pending List Of Parent MPS"
    },
    model: {
      value: (_vm.showModalForCargoPendingList),
      callback: function($$v) {
        _vm.showModalForCargoPendingList = $$v
      },
      expression: "showModalForCargoPendingList"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Pending List Of Parent MPS")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModalForCagoPending
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Paper Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Stop Point Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Scan Out")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pending MPS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Position")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Offload")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.pendingMpsCount), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.paperbagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.stoppointhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.npscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.scheduledmpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pendingmpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.position))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.ShowMPSInscanFunction(data)
        }
      }
    }, [_vm._v("Offload")])])])
  }), _vm._v(" "), ((_vm.pendingMpsCount && _vm.pendingMpsCount.length == 0) || _vm.pendingMpsCount.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.pendingMpsCount.length > 0) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ShowMPSInscan),
      expression: "ShowMPSInscan"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('b-form-fieldset', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Parent AWB")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.parentawb),
      expression: "parentawb"
    }],
    attrs: {
      "type": "text",
      "placeholder": "ParentAWB No.",
      "name": "parentawb",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.parentawb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.parentawb = $event.target.value
      }
    }
  }), _c('br'), (_vm.showValidationMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please Select ParentAWB For Offload")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.childmps),
      expression: "childmps"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('ChildMps')
    },
    attrs: {
      "type": "text",
      "name": "ChildMps",
      "id": "childmps",
      "placeholder": "Enter ChildMPS/ParentAWB",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.childmps)
    },
    on: {
      "keydown": function($event) {
        return _vm.restrictManualTyping($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.childmps = $event.target.value
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ChildMps')),
      expression: "errors.has('ChildMps')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ChildMps')))])]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn-success",
    on: {
      "click": _vm.offloadMPS
    }
  }, [_vm._v("MPSInscan")])])])])])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModalForCagoPending
    }
  }, [_vm._v("Close")])])])])]), _vm._v(" "), _c('b-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "size": "sm",
      "title": "Wrong connection"
    },
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Wrong connection !!! ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('span', [_vm._v(_vm._s(_vm.exceptionMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("OK")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.schedulemodal = false
      }
    },
    model: {
      value: (_vm.schedulemodal),
      callback: function($$v) {
        _vm.schedulemodal = $$v
      },
      expression: "schedulemodal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeScheduleModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-1"
  }, [_c('span', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.IsAllowEcomShipment),
      expression: "IsAllowEcomShipment"
    }],
    attrs: {
      "type": "checkbox",
      "id": "IsAllowEcomShipment",
      "value": "IsAllowEcomShipment"
    },
    domProps: {
      "checked": Array.isArray(_vm.IsAllowEcomShipment) ? _vm._i(_vm.IsAllowEcomShipment, "IsAllowEcomShipment") > -1 : (_vm.IsAllowEcomShipment)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.IsAllowEcomShipment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "IsAllowEcomShipment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.IsAllowEcomShipment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.IsAllowEcomShipment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.IsAllowEcomShipment = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "IsAllowEcomShipment"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b', {
    staticStyle: {
      "color": "red",
      "margin-left": "-10%"
    }
  }, [_vm._v(_vm._s(_vm.limitexceedmsg))])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        return _vm.scanOutBag(1)
      }, function($event) {
        _vm.schedulemodal = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeScheduleModal
    }
  }, [_vm._v("No")])])])])])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), (_vm.showMultipartShipmentModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showMultipartShipmentModal),
      callback: function($$v) {
        _vm.showMultipartShipmentModal = $$v
      },
      expression: "showMultipartShipmentModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Shipment List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipartShipmentData), function(data, index) {
    return (_vm.multipartShipmentData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingId))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MultiShipmentGroupId))])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showMultipartBagModal == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Bag List"
    },
    model: {
      value: (_vm.showMultipartBagModal),
      callback: function($$v) {
        _vm.showMultipartBagModal = $$v
      },
      expression: "showMultipartBagModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Bag List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModalforbag
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Current Hub")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipartBagData), function(data, index) {
    return (_vm.multipartBagData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.multishipmentgroupid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.currenthubname))])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm.showTripConfConnModel == true) ? _c('b-modal', {
    attrs: {
      "size": "vlg",
      "title": "Pending Shipment List"
    },
    model: {
      value: (_vm.showTripConfConnModel),
      callback: function($$v) {
        _vm.showTripConfConnModel = $$v
      },
      expression: "showTripConfConnModel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Pending Bag List")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeModalForConfConn
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sr.No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bagstatus Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Multi Shipment Group Id")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tripConfConnData), function(data, index) {
    return (_vm.tripConfConnData.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.multishipmentgroupid))])]) : _vm._e()
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Change Dock"
    },
    on: {
      "show": _vm.resetChangeDockForm
    },
    model: {
      value: (_vm.showChangeDockModal),
      callback: function($$v) {
        _vm.showChangeDockModal = $$v
      },
      expression: "showChangeDockModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Change Dock")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeChangeDockModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("New Dock ID:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-building'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.dockList,
      "selected-option": _vm.newDockSelected,
      "name": "NewDockId",
      "placeholder": "Select Dock",
      "isDisabled": _vm.isNewDockDropdownDisabled
    },
    on: {
      "select": _vm.selectNewDock
    },
    model: {
      value: (_vm.newDockId),
      callback: function($$v) {
        _vm.newDockId = $$v
      },
      expression: "newDockId"
    }
  })], 1), _vm._v(" "), (_vm.newDockIdError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Please select or scan a new dock.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan New Dock Barcode:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newScannedDockBarcode),
      expression: "newScannedDockBarcode"
    }],
    ref: "scanNewDockInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "newScannedDockBarcode",
      "id": "newScannedDockBarcode",
      "placeholder": "Scan / enter dock barcode",
      "autocomplete": "off",
      "disabled": _vm.isNewScanDockBarcodeDisabled
    },
    domProps: {
      "value": (_vm.newScannedDockBarcode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onNewDockBarcodeScan.apply(null, arguments)
      },
      "change": _vm.onNewDockBarcodeScan,
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newScannedDockBarcode = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Reason:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('basic-select', {
    attrs: {
      "options": _vm.getDockChangeReasonList,
      "name": "selectedDockChangeReason",
      "selected-option": _vm.selectedDockChangeReason,
      "placeholder": "Select Reason"
    },
    on: {
      "select": _vm.selectReasonForNewDock
    }
  })], 1), _vm._v(" "), (_vm.selectedDockChangeReasonError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Reason is required.")]) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDockChange
    }
  }, [_vm._v("Update")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeChangeDockModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('i', {
    staticClass: "fa fa-refresh"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "text-primary"
  }, [_c('td'), _vm._v(" "), _c('td', [_vm._v("Parent AWB")]), _vm._v(" "), _c('td', [_vm._v("Pending")]), _vm._v(" "), _c('td', [_vm._v("Scheduled")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8f85a8","hasScoped":true}!./src/views/components/NetworkManagement/GenerateTripSheet/GenerateTripSheet.html
// module id = 979
// module chunks = 2